import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=dac3687a"
import script from "./list-table.vue?vue&type=script&lang=ts"
export * from "./list-table.vue?vue&type=script&lang=ts"
import style0 from "./list-table.vue?vue&type=style&index=0&id=dac3687a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports